import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import * as Const from '../../common/const';
import Page from '../../components/page';
import moment from 'moment';
import './index.less';
import { Input, CalendarPicker, ActionSheet, Toast } from 'antd-mobile';

const PageModel = (props) => {
    const [img, setImg] = useState(['','','']);
    const [uptime, setUptime] = useState('')
    const [upcomany, setUpcompany] = useState('');
    const [updesc, setUpdesc] = useState('');
    const [name, setName] = useState('');
    const [tel, setTel] = useState('');
    const [visible, setVisible] = useState(false)
    const [visible1, setVisible1] = useState(false)
    const [singleDate, setSingleDate] = useState(new Date('2021-08-01'))
    const [listdd1, setListdd1] = useState([])

    useEffect(() => {
        console.log('保养项目');
        console.log('baoyang===',props.baoyang);
        if(props.baoyang){
            setListdd1(props.baoyang)
        }
    }, [123]);

    const select = (index) => {
        //修改数组并重新赋值
       let arr2 = [...listdd1];
       let ints = index;
       arr2[ints].isflag = !arr2[ints].isflag;
       console.log(JSON.stringify(arr2));
       setListdd1(arr2);
    }
    const add = async() => {
        
        if (!uptime || !upcomany || !name || !tel || listdd1.filter(item=>item.isflag).length == 0) {
            Toast.show({
                content: '请完善信息',
                afterClose: () => {
                    console.log('after')
                },
            })
            return
        }
        //新增保养项目
        const result = await Request.post({
            url: '/company/upkeep/add',
            data: {
                equipmentId:props.id,
                equipmentUpkeepDays:uptime,
                upcomany:upcomany,
                upname:name,
                uptel:tel,
                updesc:updesc,
                upfile:img.filter(item=>item!='').join(','),
                uptype:'1',
                upcontent:listdd1.filter(item=>item.isflag).map(item=>item.id).join(',')
            }
        });

        console.log('result', result);
        if(result.ok == 0){
            Toast.show('提交成功')
            props.props.history.goBack(-1);
        }
    }
    //图片上传
    const uploadHandle = async (e, idx) => {
        const selectedFile = e.target.files[0];
        const formData = new FormData();
        formData.append('file', selectedFile);
        const result = await Request.uploadFetch({
        	url: '/problem/upload',
        	method:'POST',
        	data: formData
        });
        if(!result) return;
        const src = result.data.src;
        console.log('上传图片的src===', src);
        img[idx] = src;
        setImg([...img]);
    };

    return (
        <Page {...{ page: 'upkeepdetail', showFooter: false, title: '设备保养' }} {...props}>
            <section className="upkeepdetail-baoyang">
                <div className="upkeepdetail-baoyang-container" onClick={() => setVisible1(true)}>
                    <div className="upkeepdetail-baoyang-title">上报日期</div>
                    <div className="upkeepdetail-baoyang-content1">{uptime}</div>
                </div>
                <CalendarPicker
                    visible={visible1}
                    selectionMode='single'
                    defaultValue={singleDate}
                    onClose={() => setVisible1(false)}
                    onMaskClick={() => setVisible1(false)}
                    onChange={val => {
                        console.log(val)
                        setUptime(moment(val).format('YYYY-MM-DD'))
                    }}
                />
                <div className="upkeepdetail-baoyang-container" onClick={() => setVisible(true)}>
                    <div className="upkeepdetail-baoyang-title">保养单位</div>
                    <div className="upkeepdetail-baoyang-content1" >{upcomany}</div>
                </div>
                {props.hscomp && 
                <ActionSheet
                    visible={visible}
                    actions={props.hscomp}
                    onAction={(key) => {
                        setUpcompany(key.text)
                    }}
                    closeOnAction={true}
                    onClose={() => setVisible(false)}
                />}
                
                <div className="upkeepdetail-baoyang-container">
                    <div className="upkeepdetail-baoyang-title">保养人</div>
                    <div className="upkeepdetail-baoyang-content1"><Input placeholder="请输入保养人姓名" onChange={(e) => {
                        setName(e)
                    }}/></div>
                </div>
                <div className="upkeepdetail-baoyang-container">
                    <div className="upkeepdetail-baoyang-title">联系电话</div>
                    <div className="upkeepdetail-baoyang-content1"><Input type='number' maxLength={11} placeholder="请输入有效手机号" onChange={(e)=>{
                        setTel(e)
                    }}/></div>
                </div>
                <div className="upkeepdetail-baoyang-container">
                    <div className="upkeepdetail-baoyang-title">保养项目</div>
                </div>
                <div className="upkeepdetail-baoyang-container-div">
                    {
                        props.baoyang && props.baoyang.map((item, index) => {
                            return (
                                <div key={index} className={`upkeepdetail-item ${item.isflag ? 'select' : ''} `} onClick={()=>select(index)}>{item.name}</div>
                            )
                        })
                    }
                </div>
                <div className="upkeepdetail-baoyang-container">
                    <div className="upkeepdetail-baoyang-title">备注说明</div>
                    <div className="upkeepdetail-baoyang-content1"><Input placeholder="请输入" onChange={(e) => { setUpdesc(e)}} /></div>
                </div>
                <div className="upkeepdetail-baoyang-container">
                    <div className="upkeepdetail-baoyang-title">保养照片(1-3张)</div>
                </div>
                <div className="picture-wrap">
                    {
                        img && img.length > 0 && img.map((item, idx) => {
                            if (idx >= 3) return null;
                            return (
                                <div className="item" key={idx}>
                                    {item && <img src={Const.imgPrefix + item} />}
                                    {item && <div className="close" onClick={() => {
                                        const covers = [...img];
                                        covers.splice(idx, 1);
                                        for (let i = 0, _len = 3 - covers.length; i < _len; i++) {
                                            covers.push('');
                                        }
                                        setImg([ ...covers ]);

                                    }} />}
                                    <input type="file" accept="image/*" onChange={(e) => {
                                        uploadHandle(e, idx);
                                    }} />
                                </div>
                            )
                        })
                    }
                </div>

                <div className="upkeepdetailadd" onClick={add}>提交</div>
            </section>
        </Page>
    );
};

export default PageModel;
